export const COMPLIANCE_LEVEL = {
  CUMPLE: 1,
  NO_CUMPLE: 2,
  CUMPLE_PARCIALMENTE: 3,
  NO_APLICA: 4,
};

export const COMPLIANCE_LEVEL_CONFIG = {
  1: {
    label: "C",
  },
  2: {
    label: "NC",
  },
  3: {
    label: "CP",
  },
  4: {
    label: "NA",
  },
};
